import * as React from 'react';
import { Dispatch, connect } from "react-redux";
import { getDentists, requestDentists } from "../../redux/actions/find-a-dentist-api";
import { setPage, updateTextFilter } from "../../redux/actions/actions";
import { FindAPDAppState } from "../../classes/redux-states";

export interface DispatchToProps {
	requestDentists: (page: number) => any;
	setPage: (page: number) => any;
    updateTextFilter: (filterName: string, filterValue: string) => any;
}

export class FilterItemZipCodeComponent extends React.Component<DispatchToProps, any> {
	constructor(props: DispatchToProps) {
		super(props);

		this.textChangeEvent = this.textChangeEvent.bind(this);
		this.getResults = this.getResults.bind(this);
    }

	textChangeEvent(event) {
        this.props.updateTextFilter("zipCode", event.target.value);
	}

	getResults(event) {
		if (event.which == '13') {
			this.props.requestDentists(1);
			this.props.setPage(1);
		}
	}

	render() {

        return (
            <div className="find-a-pd-filters-panel-item">
				<label htmlFor="zipCode">Zip Code</label>
				<input id="zipCode" type="text" maxLength={7} name="zipCode" placeholder="Enter ZIP code here" onKeyPress={this.getResults} onChange={this.textChangeEvent} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
    return {
		requestDentists: (page: number) => dispatch(getDentists(page)),
		setPage: (page: number) => dispatch(setPage(page)),
		updateTextFilter: (filterName: string, filterValue: string) => dispatch(updateTextFilter(filterName, filterValue)),
    }
}

export default connect(null, mapDispatchToProps)(FilterItemZipCodeComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filter-item-zipcode.tsx